import { Box, Flex } from '@chakra-ui/react';
import { MinusIcon, PlusIcon } from '@/_assets/icon-components';

interface ICounter {
  variable: number;
  bg?: string | Record<string, string>;
  onIncrease: () => void;
  onDecrease: () => void;
  min?: number;
  height?: number | string | any;
  width?: number | string;
  max?: number;
  isDisabled?: boolean;
  isBrand?: boolean;
}

export default function Counter({
  min,
  max,
  bg,
  variable,
  onIncrease,
  onDecrease,
  isDisabled,
  height,
  width = 'full',
  isBrand,
}: ICounter) {
  const resolvedWidth = isBrand ? '83px' : width;
  const controlWidth = isBrand ? '28px' : '36px';
  const valueWidth = isBrand ? '16px' : '20px';

  return (
    <Flex
      w={resolvedWidth}
      rounded={12}
      alignItems='center'
      bg={bg ? bg : 'light'}
      justify='space-between'
      h={height ? height : 'auto'}
      px={isBrand ? 1 : 2}
      gap={1}
    >
      <Box
        as={isBrand ? 'button' : undefined}
        w={controlWidth}
        h='full'
        display='flex'
        alignItems='center'
        justifyContent='center'
        borderRadius={12}
        bg='transparent'
        cursor={isDisabled || min === variable ? 'not-allowed' : 'pointer'}
        onClick={!isDisabled && min !== variable ? onDecrease : undefined}
      >
        <MinusIcon size={isBrand ? 16 : 20} />
      </Box>

      <Box
        as='span'
        w={valueWidth}
        textAlign='center'
        fontWeight={600}
        color='product_button.text'
        fontSize='sm'
      >
        {variable}
      </Box>

      <Box
        as={isBrand ? 'button' : undefined}
        w={controlWidth}
        h='full'
        display='flex'
        alignItems='center'
        justifyContent='center'
        borderRadius={12}
        bg='transparent'
        cursor={isDisabled || max === variable ? 'not-allowed' : 'pointer'}
        onClick={!isDisabled && max !== variable ? onIncrease : undefined}
      >
        <PlusIcon color='var(--product-btn-text)' size={isBrand ? 16 : 20} />
      </Box>
    </Flex>
  );
}
